import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { ShopIndexResponse } from '@/repositories/generated';

const content: ShopIndexResponse[] = [
  {
    name: 'テスト店舗００１',
    externalShopId: 'shop01',
    id: '000000001',
    status: 'AVAILABLE',
    defaultShop: true,
    companyName: 'テスト企業００１',
    startDate: '2023-01-08',
    endDate: '2023-12-31',
    createdAt: '2023-04-23T00:00:00+09:00',
    isSmartCode: false,
  },
  {
    name: 'テスト店舗００２',
    externalShopId: 'shop02',
    id: '000000002',
    status: 'WAITING',
    defaultShop: false,
    companyName: 'テスト企業００２',
    startDate: '2021-01-08',
    endDate: '2030-12-31',
    createdAt: '2020-04-23T00:00:00+09:00',
    isSmartCode: false,
  },
  {
    name: 'テスト店舗００３',
    externalShopId: 'shop03',
    id: '000000003',
    status: 'CLOSED',
    defaultShop: false,
    companyName: 'テスト企業００３',
    startDate: '2022-01-08',
    endDate: '2025-12-31',
    createdAt: '2021-04-23T00:00:00+09:00',
    isSmartCode: false,
  },
  {
    name: 'テスト店舗００４',
    externalShopId: 'shop04',
    id: '000000004',
    status: 'AVAILABLE',
    defaultShop: false,
    companyName: 'テスト企業００４',
    startDate: '2022-01-08',
    endDate: '2025-12-31',
    createdAt: '2021-04-23T00:00:00+09:00',
    isSmartCode: true,
  },
  {
    name: 'テスト店舗００５',
    externalShopId: 'shop05',
    id: '000000005',
    status: 'WAITING',
    defaultShop: false,
    companyName: 'テスト企業００５',
    createdAt: '2021-04-23T00:00:00+09:00',
    isSmartCode: true,
  },
  {
    name: 'テスト店舗００６',
    externalShopId: 'shop06',
    id: '000000006',
    defaultShop: false,
    companyName: 'テスト企業００６',
    createdAt: '2021-04-23T00:00:00+09:00',
    isSmartCode: true,
  },
];

const loopContent = new Array<string>(50)
  .fill('')
  .map((_, i) => content[i % content.length]);

export const shop = http.get(
  createMockEndpoint('/shop'),
  async ({ request }) => {
    const url = new URL(request.url);
    await delay(500);
    const shopExists = url.searchParams.get('shopNames') ?? '';
    const externalExists = url.searchParams.get('externalShopIds') ?? '';
    const companyExists = url.searchParams.get('companyNames') ?? '';

    if (shopExists || externalExists || companyExists) {
      return HttpResponse.json({
        content: loopContent.slice(3, 25),
        pageable: {
          sort: {
            empty: true,
            sorted: false,
            unsorted: true,
          },
          offset: 0,
          pageNumber: 0,
          pageSize: 20,
          paged: true,
          unpaged: false,
        },
        last: true,
        totalPages: 1,
        totalElements: 20,
        size: 20,
        number: 0,
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        first: true,
        numberOfElements: 20,
        empty: false,
      }, { status: 200 });
    }
    // クエリパラメータなし
    return HttpResponse.json({
      content: loopContent,
      pageable: {
        sort: {
          empty: true,
          sorted: false,
          unsorted: true,
        },
        offset: 0,
        pageNumber: 0,
        pageSize: 20,
        paged: true,
        unpaged: false,
      },
      last: true,
      totalPages: 1,
      totalElements: 50,
      size: 50,
      number: 0,
      sort: {
        empty: true,
        sorted: false,
        unsorted: true,
      },
      first: true,
      numberOfElements: 50,
      empty: false,
    }, { status: 200 });
  },
);
